import { iconsList } from './map-marker-layer.constants';

const svgStringToImageSrc = (svgString) => {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
};

async function addImages(map) {
  await Promise.all(iconsList.map((icon) => {
    return new Promise((resolve) => {
      const img = new Image(32, 32);
      img.onload = () => {
        if (!map.hasImage(icon.name)) {
          map.addImage(icon.name, img);
        }
        resolve();
      };

      img.src = svgStringToImageSrc(icon.svg);
    });
  }));
}

async function addLayers(map) {
  map.addLayer({
    source: 'boundaries-regions',
    id: 'kasungu-fill',
    type: 'fill',
    filter: ['==', ['get', 'shapeName'], 'Kasungu'],
    paint: {
      'fill-color': '#CEE8D1',
      'fill-opacity': 0.5,
    },
  });
          
  map.addSource('points', {
    type: 'geojson',
    data: [],
    cluster: true,
    clusterMaxZoom: 14,
    clusterRadius: 50,
  });

  map.addLayer({
    id: 'points-shadow',
    type: 'circle',
    source: 'points',
    filter: ['all', ['!', ['has', 'point_count']], ['==', ['get', 'id'], -1]],
    paint: {
      'circle-color': 'rgba(0,0,0,0.45)',
      'circle-radius': 26,
      'circle-blur': 0.8,
      'circle-translate': [0, 8],
      'circle-translate-anchor': 'map',
    },
  });

  map.addLayer({
    id: 'points',
    type: 'symbol',
    source: 'points',
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-image': [
        'case',
        ['==', ['get', 'category'], 'Plan'], 'plan-icon',
        ['==', ['get', 'category'], 'Story'], 'story-icon',
        'plan-icon',
      ],
      'icon-size': 1,
      'icon-allow-overlap': false,
    },
  });

  map.addLayer({
    id: 'clusters',
    type: 'circle',
    source: 'points',
    filter: ['has', 'point_count'],
    paint: {
      'circle-color': '#ddd',
      'circle-radius': [
        'step',
        ['get', 'point_count'],
        20,
        10,
        30,
        30,
        40,
      ],
      'circle-stroke-width': 2,
      'circle-stroke-color': '#ffffff',
    },
  });

  map.addLayer({
    id: 'cluster-count',
    type: 'symbol',
    source: 'points',
    filter: ['has', 'point_count'],
    layout: {
      'text-field': '{point_count_abbreviated}',
      'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
      'text-size': 12,
    },
    paint: {
      'text-color': 'black',
    },
  });

  await addImages(map);
}

function removeLayers(map) {
  if (map.getLayer('points-shadow')) map.removeLayer('points-shadow');
  if (map.getLayer('clusters')) map.removeLayer('clusters');
  if (map.getLayer('cluster-count')) map.removeLayer('cluster-count');
  if (map.getLayer('kasungu-fill')) map.removeLayer('kasungu-fill');

  if (map.getSource('points')) {
    map.removeLayer('points');
    map.removeSource('points');
  }
}

export {
  addImages,
  addLayers,
  removeLayers,
};